const BookIcon = ({ isLink = false }: { isLink?: boolean }) => {
  return isLink ? (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='20'
      height='20'
      viewBox='0 0 20 20'
      fill='none'
    >
      <path
        d='M10.8333 17.5V19.1667H9.16663V17.5H2.49996C2.27895 17.5 2.06698 17.4122 1.9107 17.2559C1.75442 17.0996 1.66663 16.8877 1.66663 16.6667V3.33334C1.66663 3.11232 1.75442 2.90036 1.9107 2.74408C2.06698 2.5878 2.27895 2.5 2.49996 2.5H7.49996C7.97295 2.49944 8.44061 2.5998 8.87173 2.79437C9.30284 2.98895 9.68748 3.27327 9.99996 3.62834C10.3124 3.27327 10.6971 2.98895 11.1282 2.79437C11.5593 2.5998 12.027 2.49944 12.5 2.5H17.5C17.721 2.5 17.9329 2.5878 18.0892 2.74408C18.2455 2.90036 18.3333 3.11232 18.3333 3.33334V16.6667C18.3333 16.8877 18.2455 17.0996 18.0892 17.2559C17.9329 17.4122 17.721 17.5 17.5 17.5H10.8333ZM16.6666 15.8333V4.16667H12.5C12.0579 4.16667 11.634 4.34226 11.3214 4.65482C11.0089 4.96738 10.8333 5.39131 10.8333 5.83334V15.8333H16.6666ZM9.16663 15.8333V5.83334C9.16663 5.39131 8.99103 4.96738 8.67847 4.65482C8.36591 4.34226 7.94199 4.16667 7.49996 4.16667H3.33329V15.8333H9.16663Z'
        fill='#0000C9'
      />
    </svg>
  ) : (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='24'
      height='24'
      viewBox='0 0 24 24'
      fill='none'
    >
      <path
        d='M13 21V23H11V21H3C2.73478 21 2.48043 20.8946 2.29289 20.7071C2.10536 20.5196 2 20.2652 2 20V4C2 3.73479 2.10536 3.48043 2.29289 3.2929C2.48043 3.10536 2.73478 3 3 3H9C9.56759 2.99933 10.1288 3.11976 10.6461 3.35325C11.1635 3.58674 11.625 3.92792 12 4.354C12.375 3.92792 12.8365 3.58674 13.3539 3.35325C13.8712 3.11976 14.4324 2.99933 15 3H21C21.2652 3 21.5196 3.10536 21.7071 3.2929C21.8946 3.48043 22 3.73479 22 4V20C22 20.2652 21.8946 20.5196 21.7071 20.7071C21.5196 20.8946 21.2652 21 21 21H13ZM20 19V5H15C14.4696 5 13.9609 5.21072 13.5858 5.58579C13.2107 5.96086 13 6.46957 13 7V19H20ZM11 19V7C11 6.46957 10.7893 5.96086 10.4142 5.58579C10.0391 5.21072 9.53043 5 9 5H4V19H11Z'
        fill='#18181B'
      />
    </svg>
  );
};

export default BookIcon;
